import { useState } from 'react';

import { AddPaymentMethodForm } from './AddPaymentMethodForm/AddPaymentMethodForm';
import { EditPaymentMethod } from './EditPaymentMethod/EditPaymentMethod';
import { useGetFundingRequirement } from '../../../../api/lending/lapiHooks';
import { Button } from '../../../components/Button/Button';
import { Card } from '../../../components/Card/Card';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { getRequirementByResolutionMethod } from '../../helpers/requirements';
import { useIsNonLinearFlow } from '../../hooks/useIsNonLinearFlow.hook';

export const AddPaymentMethod = () => {
  const { isNonLinearFlow } = useIsNonLinearFlow();
  const { fundingRequirement } = useGetFundingRequirement();
  const addPaymentMethodFundingRequirement = getRequirementByResolutionMethod(
    fundingRequirement!,
    'add_default_payment_method',
  )!;

  const canEditPaymentMethod =
    isNonLinearFlow &&
    addPaymentMethodFundingRequirement.status === 'completed';

  const title = canEditPaymentMethod
    ? 'Edit payment method'
    : 'Set up automatic payments today';

  const [showAddPaymentMethodForm, setShowAddPaymentMethodForm] =
    useState(false);

  return (
    <Card title={title}>
      {!canEditPaymentMethod && (
        <p>Add a debit card now to make your monthly payments automatically.</p>
      )}

      {canEditPaymentMethod ? (
        <EditPaymentMethod />
      ) : (
        <div>
          {showAddPaymentMethodForm ? (
            <AddPaymentMethodForm />
          ) : (
            <WhiteLabelOverride componentType="button" disabled={false}>
              <Button
                onClick={() => setShowAddPaymentMethodForm(true)}
                className="sm:w-full"
              >
                Add debit card now
              </Button>
            </WhiteLabelOverride>
          )}
        </div>
      )}
    </Card>
  );
};
